var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "column" }, [
    _c("div", { staticClass: "col" }, [
      _c("span", { staticClass: "text-overline" }, [
        _vm._v(_vm._s(_vm.$t("viewType")))
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col" },
      [
        _c(
          "q-btn-group",
          [
            _c("q-btn", {
              class: _vm.viewButtonClass(_vm.teaser),
              attrs: { icon: "view_module" },
              on: {
                click: function($event) {
                  return _vm.$emit("input", _vm.teaser)
                }
              }
            }),
            _vm._v(" "),
            _c("q-btn", {
              class: _vm.viewButtonClass(_vm.table),
              attrs: { icon: "view_column" },
              on: {
                click: function($event) {
                  return _vm.$emit("input", _vm.table)
                }
              }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }